import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../@types/RootState';

const initialState = false;

const slice = createSlice({
  name: 'ipa.gerenciador.bigNumbers.shouldUpdateBigNumbers',
  initialState,
  reducers: {
    SET_SHOULD_UPDATE_BIG_NUMBERS(_state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { SET_SHOULD_UPDATE_BIG_NUMBERS } = slice.actions;

export default slice.reducer;

export const selectorShouldUpdateBigNumbers = (state: RootState) => state.gerenciadorPrecosReducer.bigNumbers.shouldUpdateBigNumbers;
